import { Box, Grid, Skeleton } from "@mui/material";

export default function TradeFormSkeleton() {
  return (
    <Grid container spacing={2}>
      <Grid xs={8} item>
        <Skeleton variant="h3"></Skeleton>

        <Box py={1}>
          <Skeleton variant="rounded" height={45} width="100%"></Skeleton>
        </Box>

        <Box pb={1}>
          <Skeleton variant="rounded" height={30} width="100%"></Skeleton>
        </Box>

        <Box pb={1}>
          <Skeleton variant="rounded" height={30} width="100%"></Skeleton>
        </Box>

        <Box display="flex" justifyContent="space-between" pb={1}>
          <Skeleton variant="rounded" height={30} width="49%"></Skeleton>
          <Skeleton variant="rounded" height={30} width="49%"></Skeleton>
        </Box>

        <Box pb={1}>
          <Skeleton variant="rounded" height={56} width="100%"></Skeleton>
        </Box>

        <Box pb={1}>
          <Skeleton variant="rounded" height={10} width="80%"></Skeleton>
        </Box>

        <Box pb={1}>
          <Skeleton variant="rounded" height={10} width="80%"></Skeleton>
        </Box>

        <Box pb={1}>
          <Skeleton variant="rounded" height={44} width="100%"></Skeleton>
        </Box>
        <Box pb={1}>
          <Skeleton variant="rounded" height={10} width="80%"></Skeleton>
        </Box>

        <Box pb={1}>
          <Skeleton variant="rounded" height={58} width="100%"></Skeleton>
        </Box>
      </Grid>
      <Grid xs={4} item>
        <Box display="flex" justifyContent="end" alignItems="center">
          <Skeleton
            animation="wave"
            variant="circular"
            width={20}
            height={20}
          />
        </Box>
        <Box py={1}>
          <Skeleton variant="rounded" height={120} width="100%"></Skeleton>
        </Box>

        <Box pb={1}>
          <Skeleton variant="rounded" height={120} width="100%"></Skeleton>
        </Box>

        <Skeleton variant="rounded" height={30} width="100%"></Skeleton>
      </Grid>
    </Grid>
  );
}
